import ApiService from "@/utils/api.service";

export default {

    create(context, user) {
        return new Promise((resolve, reject) => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.post("user", user)
                .then(({ data }) => {
                    resolve(data);
                }).catch(({ response }) => {
                    reject(response.data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    update(context, user) {
        return new Promise((resolve, reject) => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.put("user/" + user.id, user)
                .then(({ data }) => {
                    resolve(data);
                }).catch(({ response }) => {
                    reject(response.data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },

    delete(context, user) {
        return new Promise((resolve, reject) => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.delete("user/" + user.id)
                .then(({ data }) => {
                    resolve(data);
                }).catch(({ response }) => {
                    reject(response.data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },

}